import { createTheme } from "@mui/material";


export const VM_Colors = {
  primary: "#1E3A8A",//"#242021",
  secondary: "#feb449",//"#FBC600",
  steel_gray: "#94969A",
  hint_color: "#B5B5B5",
  light_gray: "#D9D9D9",
  paper_bg:"#F5F5F5",
  light_green: "#6EBF4A",
  dark_green: "#3E8529",
  teal: "#34657F",
  turquoise: "#58A7AF",
  purpule: "#84329B",
  white : "#FFFFFF",
  white1:"#F4F7FD",
  white2:"#FBFBFB",
  white_gradient:"#FFF5E0",
  black : "#000000",
  shadow: "rgba(0, 0, 0, 0.1)",
  gradient:"#C5A400",
  dark_gradient:"#695C0C",
  tansparent:"#ffffff00",
  lead:"#CC7000",
  success:"#00A10B",
  error_transparent:'rgba(255, 0, 0, 0.08)',
  error : "#FF0000"

};



export const vm_theme = createTheme({
  palette: {
    primary: {
      main: VM_Colors.primary,
    },
    secondary: {
      main: VM_Colors.secondary,
    },
  },
  typography: {
    fontFamily: "Lato, Arial, sans-serif",
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: 16,
    lineHeight: 1.5,
    letterSpacing: '0em',
    textTransform: 'none',
    h1: {
      fontSize: '25px',
      fontWeight: 600,
      lineHeight: 1.5,
    },
    h2: {
      fontSize: '24px',
      fontWeight: 600,
      lineHeight: 1.5,
    },
    h3: {
      fontSize: '18px',
      fontWeight: 500,
      // lineHeight: 1.5,
    },
    h4: {
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    h5: {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    h6: {
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    pageTitle: {
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: 1.5,
    },
    statValue: {
      fontSize: '24px',
      fontWeight: 700,
      lineHeight: 1.5,
    },
    subtitle1: {
      fontSize: '12.5px',
      lineHeight: 1.5,
    },
    subtitle2: {
      fontSize: '14px',
      lineHeight: 1.5,
      fontWeight: 700,
      color:VM_Colors.primary
    },
    button: {
      fontSize: '14px',
      textTransform: 'none',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    body1: {
      fontSize: '16px',
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '14px',
      lineHeight: 1.5,
    },
  },
  spacing: 8,
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 8,
          fontWeight: 600,
          fontSize: "14px",
        },
        sizeSmall: {
          minHeight: 30,
          fontSize: "13px",
          padding: "4px 12px",
        },
        sizeMedium: {
          minHeight: 40,
          fontSize: "14px",
          padding: "8px 16px",
        },
        sizeLarge: {
          minHeight: 44,
          fontSize: "14px",
          padding: "10px 20px",
        },
        containedPrimary: {
          backgroundColor: VM_Colors.primary,
          color: VM_Colors.white,
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
          "&:hover": {
            backgroundColor: "#162e66",
            boxShadow: "0 4px 12px rgba(30, 58, 138, 0.35)",
          },
          "&.Mui-disabled": {
            backgroundColor: `${VM_Colors.primary}66`,
            color: "rgba(255, 255, 255, 0.5)",
          },
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: 'none',
        },
        columnHeaders: {
          backgroundColor: VM_Colors.primary,
          color: '#ffffff',
          fontWeight: 600,
          fontSize: '0.875rem',
        },
        columnHeaderTitle: {
          fontWeight: 600,
          fontSize: '0.875rem',
          lineHeight: 1.25,
        },
        iconSeparator: {
          display: 'none',
        },
        cell: {
          fontSize: '14px',
        },
        footerContainer: {
          justifyContent: 'flex-end',
          padding: '8px 16px',
        },
      },
    },
  },
});

export const paperStyle = {
  // padding: 20,
  // height: "70vh",
  // width: 280,
  margin: "19px auto",
  backgroundColor: VM_Colors.white1,
  borderRadius: "12px",
  boxShadow: "0px 0px 8px rgba(0, 0, 0, 25)",
};
export const avatarStyle = { backgroundColor: VM_Colors.steel_gray };
export const vmContainedButtonSx = {
  backgroundColor: VM_Colors.primary,
  color: VM_Colors.white,
  textTransform: "none",
  fontWeight: 600,
  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
  "&:hover": {
    backgroundColor: "#162e66",
    boxShadow: "0 4px 12px rgba(30, 58, 138, 0.35)",
  },
};

/** Standard dashboard button — 40px height, 14px font */
export const vmStandardButtonSx = {
  minHeight: 40,
  fontSize: "14px",
  px: 2,
  py: 1,
  textTransform: "none",
};

/** Primary action button — 44px height, 14px font */
export const vmActionButtonSx = {
  minHeight: 44,
  minWidth: 150,
  fontSize: "14px",
  px: 2.5,
  py: 1.25,
  textTransform: "none",
  borderRadius: 2,
};

/** Header "Add" button — same height as action buttons, wider min-width */
export const vmAddButtonSx = {
  ...vmActionButtonSx,
  minWidth: 200,
};

/** Page / section heading — use with variant="pageTitle" */
export const vmPageTitleSx = {
  fontWeight: 600,
};

/** Widget / card heading — use with variant="h4" */
export const vmWidgetTitleSx = {
  fontWeight: 700,
};

/** Dashboard stat numbers — use with variant="statValue" */
export const vmStatValueSx = {
  fontWeight: 700,
};

export const btnstyle = { ...vmContainedButtonSx, margin: "12px 0" };
export const logoStyle = {
  backgroundColor: VM_Colors.steel_gray,
  // margin: "0px 0",
  width: 50,
  height: 50,
};

export const align_center = {
  display:"flex",
  justifyContent:"center",
  alignItems:"center",
  
  }

export const align_row = {
  display : 'flex',
  flexDirection : 'row',
  // justifyContent:'center',
  // alignItem : 'center'
}
export const align_column = {
  display : 'flex',
  flexDirection : 'column',
  // justifyContent:'center',
  // alignItem : 'center'
}
export const align_right = {
  // display : 'flex',
  // justifyContent:'center',
  // flexDirection: 'row-reverse',
  // alignItem : 'flex-end'
    display: 'flex',
  justifyContent: 'flex-end',  // Align items to the right
  alignItems: 'center',        // Align items vertically (adjust as needed)
  flexDirection: 'row',  
}
export const align_left = {
  display: 'flex',
  justifyContent: 'flex-start',  // horizontal alignment (left)
  alignItems: 'center',          // ✅ fixed typo: should be plural 'alignItems'
  height: '100%',
  width: '100%', 
}
export const card_css = {
  borderRadius: 5,
  padding:2,
  width: "20vw",
  height: "50vh",
  color: "black"
}
export const img_css = {
  width: "20vw",
  height: "70vh",
  borderRadius: 10,
  padding:'5px',
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center"
}


export const VM_ResponsiveBox = {
  display: "flex",
  justifyContent: "center",
  minHeight: "70vh",
  padding: { xs: 2, sm: 3 },
};

export const VM_FormContainer = {
  width: { xs: "100%", sm: "90%", md: "75%", lg: "60%" },
  bgcolor: VM_Colors.white,
  mb: 4,
};

/** Bottom padding so fixed registration footer does not cover form fields */
export const REGISTRATION_FOOTER_CLEARANCE = 12;

export const registrationStepShellSx = {
  pb: REGISTRATION_FOOTER_CLEARANCE,
};

export const VM_Header = {
  textAlign: "center",
  mb: 3,
};

export const VM_FieldGrid = {
  container: true,
  rowSpacing: 2,
  columnSpacing: { xs: 1, sm: 2, md: 3 },
};

export const VM_ButtonGroup = {
  mt: 5,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: 2, // space between buttons

};

export const VM_SubVenueCard = {
  my: 3,
  padding: 2,
  borderRadius: 2,
  boxShadow: 2,
};

export const VM_SubVenueFields = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  gap: 2,
  alignItems: "center",
  flexWrap: "wrap",
};

export const yellowBtnStyle = {
    flex: 1,
    minWidth: '200px',
    background: 'linear-gradient(93.7deg, #D67701 3.03%, #C69D6A 114.16%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    py: 2,
    textTransform: 'none', // optional: to prevent uppercase text
}

export const dataGridStyle = {
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: VM_Colors.primary,
                  },
                  "& .MuiDataGrid-columnHeader": {
                    backgroundColor: VM_Colors.primary,
                    color: "#fff",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: 600,
                    fontSize: "0.875rem",
                    lineHeight: 1.25,
                    color: "#fff",
                  },
                  "& .MuiDataGrid-iconSeparator": {
                    display: "none",
                  },
                  // Add padding to each cell (affects row spacing)
                  "& .MuiDataGrid-cell": {
                    paddingTop: '5px',
                    paddingBottom: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    whiteSpace: 'normal',
                  },
                  /** All cell content left-aligned (overrides column `align`) */
                  "& .MuiDataGrid-cell--textRight, & .MuiDataGrid-cell--textCenter": {
                    justifyContent: "flex-start !important",
                    textAlign: "left !important",
                  },
                  "& .MuiDataGrid-columnHeader--alignCenter .MuiDataGrid-columnHeaderTitleContainer":
                    {
                      justifyContent: "flex-start !important",
                    },
                  "& .MuiDataGrid-columnHeader--alignCenter .MuiDataGrid-menuIcon": {
                    marginLeft: "0 !important",
                  },
                  "& .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderDraggableContainer, & .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderTitleContainer":
                    {
                      flexDirection: "row !important",
                      justifyContent: "flex-start !important",
                    },
                  "& .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-menuIcon": {
                    marginRight: "0 !important",
                    marginLeft: "0 !important",
                  },
                  /** Show rows-per-page label on xs (DataGrid hides it via StyledPagination) */
                  "& .MuiTablePagination-selectLabel": {
                    display: "block !important",
                    marginRight: "8px",
                  },
                  "& .MuiTablePagination-input": {
                    display: "inline-flex !important",
                  },
                  // Ensure rows have a sensible min height so padding is visible
                  "& .MuiDataGrid-row": {
                    minHeight: 56,
                  },
                }
export const placeholderStyle = {
  '& .MuiOutlinedInput-root input::placeholder': {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '16px',
    color: VM_Colors.hint_color,
    opacity: 1, // important for Chrome/Safari
  },
};
